import { render, staticRenderFns } from "./AccessView.vue?vue&type=template&id=28fd4bc6&"
import script from "./AccessView.vue?vue&type=script&lang=js&"
export * from "./AccessView.vue?vue&type=script&lang=js&"
import style0 from "./AccessView.vue?vue&type=style&index=0&id=28fd4bc6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports